import classes from "../../styles/InfoLabel.module.css";
import { getClasses } from "../../utils";

type Shape = "trapezoid" | "rectangle";
type Direction = "left" | "right";

export type InfoLabelProps = {
  shape?: Shape;
  direction?: Direction;
  className?: string;
  visible?: boolean;
};
const InfoLabel: React.FC<InfoLabelProps> = (props) => {
  const shapeClass = props.shape === "rectangle" ? "rectangle" : "trapezoid";
  const directionClass = props.direction === "left" ? "left" : "right";

  if (typeof props.visible === "boolean" && !props.visible) return null;

  return (
    <div
      className={getClasses(
        classes,
        "info-label-outer",
        shapeClass,
        directionClass,
        props.className
      )}
    >
      <div className={getClasses(classes, "info-label", shapeClass)}>
        {props.children}
      </div>
    </div>
  );
};

export default InfoLabel;
